import { useState, useEffect } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enGB } from 'date-fns/locale';


function EditStay(props) {
    const { passedStudent, selectedStay, open, onClose, editStay, campuses } = props;
    const [stay, setStay] = useState({
        campus: '',
        arrivalDate: new Date(),
        departureDate: new Date(),
        residential: true,
    });

    useEffect(() => {
        if (selectedStay) {
            const safeDate = (dateString) => {
                const date = new Date(dateString);
                return date instanceof Date && !isNaN(date) ? date : new Date();
              };

            setStay({
                campus: selectedStay.campus,
                arrivalDate: safeDate(selectedStay.arrivalDate),
                departureDate: safeDate(selectedStay.departureDate),
                residential: selectedStay.residential !== false,
            });
        }
    }, [selectedStay]);

    const handleSave = () => {
        console.log(passedStudent);
        console.log(stay);
        editStay(stay, passedStudent.id, selectedStay.stayId);
        onClose();
    };

    const handleDateChange = (date, name) => {
        setStay(prevStay => ({
          ...prevStay,
          [name]: date
        }));
      };
    
    const handleChange = (event) => {
        const { name, value } = event.target;
        setStay((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Edit Stay</DialogTitle>
            <DialogContent>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                    <Stack spacing={2} mt={1}>
                        <FormControl>
                            <InputLabel id="campus-label">Campus</InputLabel>
                            <Select
                                labelId="campus-label"
                                id="campus"
                                name="campus"
                                value={stay.campus}
                                onChange={handleChange}
                                label="Campus"
                            >
                                {campuses.map((campus) => (
                                    <MenuItem key={campus.id} value={campus.name}>
                                        {campus.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <DatePicker
                            label="Arrive"
                            value={stay.arrivalDate}
                            onChange={(date) => handleDateChange(date, 'arrivalDate')}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                sx={{ mb: 0, mt: 0 }}
                            />
                            )}
                        />
                        <DatePicker
                            label="Depart"
                            value={stay.departureDate}
                            onChange={(date) => handleDateChange(date, 'departureDate')}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                sx={{ mb: 0, mt: 0 }}
                            />
                            )}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={stay.residential}
                                    onChange={(e) => setStay(prev => ({ ...prev, residential: e.target.checked }))}
                                />
                            }
                            label="Residential"
                        />
                    </Stack>
                    </LocalizationProvider>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}

export default EditStay;
